export const BANNER_DISPLAY_POSITION = {
  home_occasion: 'home_occasion_6_31',
  home_brand_subscriber: 'home_brand_subscriber_4_3',
  home_brand_not_subscriber: 'home_brand_not_subscriber'
}
